import * as React from "react";
import { connect } from "react-redux";
import { Dialog, TextField, DefaultButton, DialogType, DialogFooter, PrimaryButton } from "office-ui-fabric-react/lib";
import { RouteComponentProps } from "react-router";
import { RootState } from "~/state";
import { createFolder } from "~/state/media/action";
import { navigateToFolder } from "~/util/navigation";
export interface Props extends RouteComponentProps<{ parentId?: string}>
{
    parentId:string;
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    
});

type Navigate = (parentId: string) => void;

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    createFolder: (folderName: string, navigate: Navigate, parentId?: string) => dispatch(createFolder(folderName, navigate, parentId))
});

class NewFolder extends React.Component<Props & StateProps>
{
    folderName: string= "";
    onClose = () =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.history.push(`/media/${parentId}`);
    }

    onFolderNameChange = (event: React.FormEvent<HTMLInputElement>, value: string) =>
    {
        this.folderName = value;
    }

    onCreateFolder = () =>
    {
        this.props.createFolder(this.folderName, navigateToFolder(this.props.history), this.props.match.params.parentId);
    }

    render()
    {
        return <Dialog onDismiss={this.onClose} hidden={false} 
            dialogContentProps={{
                type: DialogType.normal,
                title: "New Folder",
            }}
            >
             <TextField  onChange={this.onFolderNameChange}></TextField>
             <DialogFooter>
                <PrimaryButton onClick={this.onCreateFolder} text="Create" />
                <DefaultButton onClick={this.onClose} text="Cancel" />
            </DialogFooter>
        </Dialog>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewFolder);


// WEBPACK FOOTER //
// ./src/components/media/NewFolder.tsx